/* eslint-disable */
export default {
  noRecords: 'Geen recente opnamen gevonden.',
  inBound: 'Inkomend',
  outBound: 'Uitgaand',
  missed: 'Gemiste oproep',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
// @key: @#@"inBound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outBound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"missed"@#@ @source: @#@"Missed Call"@#@
